import { Button, Modal } from 'antd';
import Title from 'antd/es/typography/Title';
import { CopyOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

function ViewTempPass({ open, setOpen, tempData }) {
    const [copyStatus, setCopyStatus] = useState(false)

    function copyClipordFun() {
        // window.navigator.clipboard.writeText(tempData?.pass)
        // navigator.clipboard.writeText(tempData?.pass);
        setCopyStatus(true);
        setTimeout(() => {
            setCopyStatus(false);
        }, 3000);
    }

    function backFun() {
        setOpen(false)
    }

    return (
        <Modal
            open={open}
            okText='Apply'
            cancelText='Clear All'
            onCancel={() => backFun()}
            footer={[
                <Button key="back" type='primary' onClick={backFun}>
                    Cancel
                </Button>,
            ]}
        >
            <div style={{ padding: '10px' }}>
                <div style={{ marginBottom: '20px', borderBottom: 'solid 1px #80808047' }}>
                    <Title level={5}>Temporary Password for {tempData?.firstName}</Title>
                </div>

                <div>
                    <div className="copy_text_wraper">
                        <div className='copy_text'>{tempData?.pass}</div>
                        {/* {copyStatus ? <div className='copied_text'>Copied</div> : <CopyOutlined onClick={copyClipordFun} className='copy_icon' />} */}
                        {copyStatus ? <div className='copied_text'>Copied</div>
                            :
                            <CopyToClipboard text={tempData?.pass}
                                onCopy={() => copyClipordFun()}>
                                <CopyOutlined className='copy_icon' />
                            </CopyToClipboard>}

                    </div>
                </div>


            </div>
        </Modal>
    )
}

export default ViewTempPass